import React, { forwardRef, useRef } from 'react';
import { Image } from 'antd';
import { BasePlayerRef } from '@/types';
import { DccStatus } from 'common/types';
import UnknownFile from '@/assets/image/babylon-error-img-no-bg.png';
import cx from './index.module.css';
import { GradientButton } from 'common/components';
import { useAntStaticComponent } from 'common/hooks';

const StatusToTextMap = {
  [DccStatus.Processing]: '文件检查/转换尚未完成，暂时无法预览，请耐心等待... 或下载文件至本地查看',
  [DccStatus.Fail]: '该文件无法预览，可下载文件至本地查看',
  [DccStatus.Success]: '文件解析失败 / 不支持在线预览的文件类型',
  [DccStatus.Timeout]: '该文件无法预览，原因是转换服务异常',
};
interface ErrorPreviewImageProps {
  onLoad: (data: any) => void;
  dccStatus?: DccStatus;
  downloadUrl?: string;
  errorMsgs?: string[];
}
const ErrorPreviewImage = forwardRef<BasePlayerRef, ErrorPreviewImageProps>(
  ({ onLoad, dccStatus, downloadUrl, errorMsgs }, ref) => {
    const renderImageRef = useRef<any>();
    const { message } = useAntStaticComponent();
    React.useImperativeHandle(ref, () => ({
      getElement: () => renderImageRef.current,
      takeSnapshot: async () => {
        if (!renderImageRef.current) return { image: '', params: {} };
        const html2canvas = await import('html2canvas').then((module) => module.default);
        const canvas = await html2canvas(renderImageRef.current, { useCORS: true });
        const imgData = canvas.toDataURL();
        return {
          image: imgData,
          params: {},
        };
      },
      restoreSnapshot: () => {},
    }));

    const download = () => {
      if (!downloadUrl) {
        message.error('没有可下载的文件链接');
        return;
      } else {
        //触发下载downloadUrl
        const link = document.createElement('a');
        link.href = downloadUrl;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        message.success('所有文件已下载');
      }
    };
    return (
      <div className={cx('render-canvas-error')} ref={renderImageRef}>
        <div className={cx('render-image')}>
          <Image src={UnknownFile} preview={false} width={296} height={148} onLoad={onLoad} />
          {/* <div>文件解析失败 / 不支持在线预览的文件类型</div> */}
          {dccStatus && <div>{StatusToTextMap[dccStatus]}</div>}
          {errorMsgs && <div className={'whitespace-pre-wrap'}> {errorMsgs.join('\n')}</div>}
          <GradientButton onClick={download} className="mt-xl">
            下载所有文件
          </GradientButton>
        </div>
      </div>
    );
  },
);
export default ErrorPreviewImage;
